<template>
  <div class="mobile-box">
    <van-nav-bar title="资料类型" left-arrow @click-left="back" />
    <div class="info">

      <van-cell-group inset>
        <van-cell v-if="gldInfo.invoiceNoList.length > 0" title="发票" is-link @click="toDataInfo('invoice')" />
        <van-cell v-if="gldInfo.contractNoList.length > 0" title="合同" is-link @click="toDataInfo('contract')" />
      </van-cell-group>
      <div style="font-size: 20px;margin-left: 20px;"
        v-if="gldInfo.invoiceNoList.length == 0 || gldInfo.contractNoList.length == 0">无贸易资料
      </div>
    </div>
  </div>
</template>
<script>
import './mobile.less'
import { getVoucherDetail } from '@/api/mobile.js'

export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {
      gldInfo: {}
    }
  },
  created() {
    console.log(this.$route.params.gldId)
  },
  mounted() {
    getVoucherDetail({ gldId: this.gldId, tenantIds: this.tenantIds }).then(res => {
      console.log(res)
      this.gldInfo = res.data
    })
  },
  computed: {
    gldId() {
      return this.$route.params.gldId
    },
    tenantIds() {
      return this.$route.query.tenantIds
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    toDataInfo(type) {
      const dataList = type == 'invoice' ? this.gldInfo.invoiceNoList : this.gldInfo.contractNoList
      this.$router.push({
        name: "mobile/dataInfo",
        params: { dataList },//这种方式的传参必须要有路由的别名name
      })
    }

  }
}
</script>

<style scoped lang="less">
/deep/ .van-icon-arrow-left {
  color: #a5a5a5 !important;
}
</style>



// WEBPACK FOOTER //
// src/mobile/DataType.vue